import { defineComponent as _defineComponent } from 'vue'
import PasswordProgress from "@/components/ui/PasswordProgress.vue";
  import useVuelidate from "@vuelidate/core";
  import { helpers, required, sameAs } from "@vuelidate/validators";
  import { validatePassword } from "@/helpers/validation";
  import InputPassword from "@/components/ui/input/InputPassword.vue";
  import { computed, ref } from "vue";
  import router from "@/router";
  import { useStore } from "vuex";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";
  import {
    confirmPasswordError,
    newPasswordError,
  } from "@/constants/validation";
  import { POSITION, useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerProfileChangePasswordView',
  setup(__props, { expose: __expose }) {
  __expose();

  const toast = useToast();
  const store = useStore();
  const errorMessage = ref("");
  const rules = computed(() => ({
    currentPassword: { required },
    password: {
      required,
      validatePassword: helpers.withMessage(newPasswordError, validatePassword),
    },
    confirmPassword: {
      required,
      sameAsPassword: helpers.withMessage(
        confirmPasswordError,
        sameAs(form.value.password)
      ),
    },
  }));
  const form = ref({
    currentPassword: "",
    password: "",
    confirmPassword: "",
  });
  const v$ = useVuelidate(rules, form);

  function onBack() {
    router.push({ name: "CustomerProfile" });
  }
  function onCancel() {
    clearForm();
    router.push({ name: "CustomerProfile" });
  }
  function clearForm() {
    form.value = {
      currentPassword: "",
      password: "",
      confirmPassword: "",
    };
  }
  const submitForm = async () => {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    store
      .dispatch("user/changePasswordForLoginUser", {
        oldPassword: form.value.currentPassword,
        newPassword: form.value.password,
      })
      .then(() => {
        errorMessage.value = "";
        router.push({ name: "CustomerProfile" });
        toast.success("The password was updated successfully.", {
          position: POSITION.TOP_LEFT,
        });
      })
      .catch((error) => {
        const { message } = error.response.data;

        errorMessage.value = Array.isArray(message) ? message[0] : message;
      })
      .finally(() => {
        resetVuelidateErrors(v$);
        setTimeout(() => {
          clearForm();
        });
      });
  };

const __returned__ = { toast, store, errorMessage, rules, form, v$, onBack, onCancel, clearForm, submitForm, PasswordProgress, get useVuelidate() { return useVuelidate }, get helpers() { return helpers }, get required() { return required }, get sameAs() { return sameAs }, get validatePassword() { return validatePassword }, InputPassword, computed, ref, get router() { return router }, get useStore() { return useStore }, get resetVuelidateErrors() { return resetVuelidateErrors }, get confirmPasswordError() { return confirmPasswordError }, get newPasswordError() { return newPasswordError }, get POSITION() { return POSITION }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})